import paths from "routes/paths";
import AbstractApi from "services/cores/abstractApi";

const AvailableParkingApi = new AbstractApi({
  paths: {
    default: paths.api.parkStatistics.dataByRadius.availableParking,
    byAreas: paths.api.parkStatistics.dataByAreas.availableParking,
    byRadius: paths.api.parkStatistics.dataByRadius.availableParking,
  },
});

export default AvailableParkingApi;
